import { Permission } from "@/api/dtos";
import { boxClasses, buttonBaseClasses, formControlClasses, formControlLabelClasses, formGroupClasses, grid2Classes } from "@mui/material";
import { ValidateOn } from "@ngt/forms-core";
import { CollaboratingGroupContext, CrfForm, DatePicker, FormBreadcrumbs, GroupedField, InstitutionContext, MasterGroupContext, PageLayout, PatientContext, RadioGroup, RouteLoading, Select, Text } from "@ngt/opms";
import { usePermissionsByIds } from "@ngt/opms-bctapi";
import { FC, useContext } from "react";
import LabelWithTooltip from "../labels/LabelWithTooltip";
import { crfReadOnly } from "@/utils/CrfFormUtils";

interface IRegistrationFormContentProps {

}

export const RegistrationFormContent: FC<IRegistrationFormContentProps> = ({

}) => {
    return (
        <>
            <GroupedField
                propertyPath="instId"
                component={Select}
                FieldGridProps={{
                    size: {
                        xl: 5,
                        lg: 5,
                        md: 5,
                        sm: 5,
                        xs: 12
                    }
                }}
                disabled
            />
            <GroupedField 
                propertyPath="initials"
                component={Text}
                LabelProps={{
                    label: <LabelWithTooltip content="First name initial, Middle name initial, Last name initial" />
                }}
                FieldGridProps={{
                    size: {
                        xl: 5,
                        lg: 5,
                        md: 5,
                        sm: 5,
                        xs: 12
                    }
                }}
            />
            <GroupedField
                propertyPath="dob"
                component={DatePicker}
                format="dd-MMM-yyyy"
                FieldGridProps={{
                    size: {
                        xl: 5,
                        lg: 5,
                        md: 5,
                        sm: 5,
                        xs: 12
                    }
                }}
            />
            <GroupedField 
                propertyPath="consentDate"
                component={DatePicker}
                format="dd-MMM-yyyy"
                FieldGridProps={{
                    size: {
                        xl: 5,
                        lg: 5,
                        md: 5,
                        sm: 5,
                        xs: 12
                    }
                }}
            />
            <GroupedField 
                propertyPath="consentedToBloodStorage"
                component={RadioGroup}
                enableMarkdown
                ContainerGridProps={{
                    sx: {
                        [`&.${grid2Classes.root}`]: {
                            alignItems: "flex-start"
                        }
                    }
                }}
                LabelGridProps={{
                    sx: {
                        pr: {
                            xs: 0,
                            sm: 5
                        },
                    }
                }}
                FieldGridProps={{
                    size: {
                        xl: 5,
                        lg: 5,
                        md: 5,
                        sm: 5,
                        xs: 12
                    },
                    sx: {
                        [`&.${grid2Classes.root}`]: {
                            [`.${boxClasses.root}`]: {
                                [`.${boxClasses.root}`]: {
                                    [`.${formControlClasses.root}`]: {
                                        [`.${formGroupClasses.root}`]: {
                                            gap: 3,
                                            [`.${formControlLabelClasses.root}`]: {
                                                alignItems: "flex-start",
                                                [`.${buttonBaseClasses.root}`]: {
                                                    pt: 0
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }}
            />
        </>
    )
}

interface IRegistrationFormProps {

}

const RegistrationForm: FC<IRegistrationFormProps> = ({

}) => {

    const { data: masterGroup } = useContext(MasterGroupContext);
    const { data: collaboratingGroup } = useContext(CollaboratingGroupContext);
    const { data: institution } = useContext(InstitutionContext);
    const { data: patient } = useContext(PatientContext);

    const {
        permissions: [
            canUpdateCrf
        ],
        loading: permissionsLoading
    } = usePermissionsByIds(
        [
            Permission.OpmsCrfUpdate
        ], 
        masterGroup?.id, 
        collaboratingGroup?.id, 
        institution?.id, 
        patient?.id
    );

    return (
        <PageLayout breadcrumbs={<FormBreadcrumbs />}>
            {
                !permissionsLoading ?
                <CrfForm 
                    validateOn={ValidateOn.onChange}
                    readOnly={crfReadOnly(canUpdateCrf)}
                    enableQueries
                >
                    <RegistrationFormContent />
                </CrfForm> :
                <RouteLoading />
            }
        </PageLayout>
    );
}

export default RegistrationForm;